<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1 style="padding-bottom: 35px;">Acknowledgements</h1>
<p>I have no specific acknowledgements other than the many who were thanked in my first book, but I am deeply grateful to them all and they know who they are.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?8cf96fd2